import { Controller } from "@hotwired/stimulus"

// Auto-dismisses flash messages after a few seconds so they don't sit on
// screen (or keep pushing page content down) forever.
export default class extends Controller {
  static values = { delay: { type: Number, default: 4000 } }

  connect() {
    this.timeout = setTimeout(() => this.dismiss(), this.delayValue)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  dismiss() {
    this.element.classList.add("opacity-0", "-translate-y-2")
    // Don't rely on the `transitionend` event — it doesn't reliably fire in
    // every browser/rendering context, so fall back to a plain timeout that
    // matches the CSS transition duration (duration-500 = 500ms) instead.
    setTimeout(() => this.element.remove(), 500)
  }
}
